var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0C23.7842 0 30.5 6.71584 30.5 15C30.5 23.2842 23.7842 30 15.5 30C7.21583 30 0.5 23.2842 0.5 15C0.5 6.71584 7.21583 0 15.5 0Z",
    fill: "#0052FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5065 20.2711C12.5911 20.2711 10.2354 17.9089 10.2354 15C10.2354 12.0911 12.5976 9.72883 15.5065 9.72883C18.116 9.72883 20.2831 11.629 20.6996 14.1215H26.0098C25.5607 8.70714 21.0314 4.45117 15.5 4.45117C9.6757 4.45117 4.95119 9.17568 4.95119 15C4.95119 20.8243 9.6757 25.5488 15.5 25.5488C21.0314 25.5488 25.5607 21.2928 26.0098 15.8785H20.6931C20.2766 18.3709 18.116 20.2711 15.5065 20.2711Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbase);
export default __webpack_public_path__ + "static/media/coinbase.7f46fb8d5d597392ce8af8c3cf9df3cd.svg";
export { ForwardRef as ReactComponent };